import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { User, UserCreate } from '../../../interfaces/User/UserWMS'

export const putUserAdminWMS = (user: User) => {
  const url = new URL(`${ApiConfig.UserAdminApi}/${user.userId}`)
  return axios.put(url.toString(), user)
}

export const postUserAdminWMS = (user: UserCreate) => {
  const url = new URL(`${ApiConfig.UserAdminApi}`)
  return axios.post(url.toString(), user)
}

export const getUserAdminWMS = (page = 0, pageSize = 10, email?: string, name?: string, warehouseId?: number, zoneId?: number, active?: string, positionCode?: string, userId?: string) => {
  const url = new URL(`${ApiConfig.UserAdminApi}`)
  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (email) url.searchParams.set('email', email)
  if (name) url.searchParams.set('name', name)
  if (warehouseId) url.searchParams.set('warehouseId', warehouseId.toString())
  if (zoneId) url.searchParams.set('zoneId', zoneId.toString())
  if (active !== undefined && active !== '-1') url.searchParams.set('active', active)
  if (positionCode) url.searchParams.set('positionCode', positionCode)
  if (userId) url.searchParams.set('userId', userId)

  return axios.get(url.toString())
}

export const getUserAdminAsignedZonesWMS = (id: number) => {
  const url = new URL(`${ApiConfig.UserAdminApi}/${id}/zones`)
  return axios.get(url.toString())
}

export interface UserAssignedZoneDto {
  zoneId: number
  zoneName: string
  warehouseId: number
  warehouseName: string
}

export interface UserZonesDto {
  userId: number
  email: string
  assignedZones: UserAssignedZoneDto[]
}

export const putUserAdminZonesWMS = (usuarioId: number, dto: UserZonesDto) => {
  const url = new URL(`${ApiConfig.UserAdminApi}/${usuarioId}`)
  return axios.put(url.toString(), dto)
}
